import { faChevronRight, faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';
import { getComponentFromName } from '../../lib/utils';

import { useTheme, useThemeClassName } from '../../contexts/ThemeContext';
import * as LogoComponents from '../icons/logos/index';
import Button from './Button';

import styles from '../../../styles/buttons/trivia.module.scss';

const propTypes = {
    className: PropTypes.string,
    question: AppPropTypes.question,
    url: PropTypes.string,
    onClick: PropTypes.func,
};

const defaultProps = {
    className: null,
    question: null,
    url: null,
    onClick: null,
};

function TriviaButton({ className, question, url, onClick }) {
    const { name: theme = null, brandedLogo = null } = useTheme();
    const themeClassName = useThemeClassName(styles);

    const {
        canAnswer = false,
        expired = false,
        points,
        validAnswer = null,
        period = null,
    } = question || {};
    const hasValidAnswer = validAnswer !== null;
    const locked = !canAnswer && !expired;
    const LogoComponent = getComponentFromName(LogoComponents, brandedLogo);

    const nhlMessage =
        period === 1 ? (
            <FormattedMessage defaultMessage="Pre-game trivia" description="sport question label" />
        ) : (
            <FormattedMessage
                defaultMessage="Intermission trivia"
                description="sport question label"
            />
        );

    const nflMessage =
        period === 3 ? (
            <FormattedMessage
                defaultMessage="Half Time Trivia Blitz"
                description="NFL question label"
            />
        ) : (
            <FormattedMessage defaultMessage="Pre-game trivia" description="sport question label" />
        );

    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [styles.locked]: locked,
                    [styles.hasValidAnswer]: hasValidAnswer,
                },
                themeClassName,
                className,
            ])}
            onClick={onClick}
            href={url}
        >
            <span className={styles.content}>
                <span className={styles.inner}>
                    <div className={styles.branded}>
                        {LogoComponent !== null ? (
                            <div className={styles.brandedIcon}>
                                <LogoComponent className={styles.brandedLogo} />
                            </div>
                        ) : null}
                        <span className={styles.brandedText}>
                            {theme === 'nfl' ? nflMessage : nhlMessage}
                        </span>
                    </div>
                </span>
                {theme !== 'nfl' ? (
                    <span className={styles.icon}>
                        <FontAwesomeIcon icon={locked ? faLock : faChevronRight} />
                    </span>
                ) : null}
            </span>
            <span className={styles.pointsAbsolute}>
                <FormattedMessage
                    defaultMessage="{count, plural, =0 {# pt} one {# pt} other {# pts}}"
                    description="pts label"
                    values={{ count: points || 0 }}
                />
            </span>
        </Button>
    );
}

TriviaButton.propTypes = propTypes;
TriviaButton.defaultProps = defaultProps;

export default TriviaButton;
